import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsIframeBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsIframeBlockEntity
